(function(){

  function initializeFinder(root) {
    var configNode = root.closest('[id^="shopify-section-"]').querySelector('[data-otr-finder-config]');
    if (!configNode) return;
    var config = JSON.parse(configNode.textContent);
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var stage = root.querySelector('[data-stage]');
    var dots = root.querySelectorAll('[data-dot]');
    var answers = {};
    var travelImg = config.travelImg;
    var titanImg = config.titanImg;
    var travelAlt = config.travelAlt;
    var titanAlt = config.titanAlt;
    var copy = config.copy;

    var steps = {
      use: {
        q: 'Where will you primarily use OTR?',
        options: [
          ['rv', 'RV or Camper'],
          ['truck', 'Truck or Vehicle'],
          ['home', 'Home or Cabin'],
          ['business', 'Mobile Business'],
          ['everywhere', 'I travel everywhere']
        ]
      },
      devices: {
        q: 'How many devices do you normally connect?',
        options: [
          ['10', '1 to 10'],
          ['16', '11 to 16'],
          ['more', 'More than 16']
        ]
      }
    };

    function priorityOptions() {
      var opts = [
        ['cost', 'Lowest cost'],
        ['coverage', 'Maximum coverage'],
        ['performance', 'Best performance']
      ];
      if (answers.devices !== 'more') opts.push(['portable', 'Portable and battery powered']);
      return opts;
    }

    function recommend() {
      if (answers.devices === 'more') return 'travel';
      if (answers.priority === 'portable') return 'titan';
      if (answers.priority === 'cost') return 'titan';
      if (answers.priority === 'coverage') return 'titan';
      return 'travel';
    }

    function why(pick) {
      if (pick === 'titan') {
        if (answers.priority === 'portable') return 'A battery powered 5G hotspot you can carry. Built for up to 16 devices.';
        if (answers.priority === 'cost') return 'The lower start price, with the hotspot and first month included.';
        if (answers.priority === 'coverage') return 'A 5G hotspot that can use more than one carrier, for up to 16 devices.';
        return 'A simple 5G hotspot for everyday use on the road.';
      }
      if (answers.devices === 'more') return 'A 4G and 5G router for bigger setups, wired gear, and up to 64 devices.';
      if (answers.use === 'home' || answers.use === 'business') return 'A 4G and 5G router with ethernet and dual band WiFi for a fixed or work setup.';
      return 'A 4G and 5G router when you want stronger WiFi and room for more gear.';
    }

    function setDots(n) {
      dots.forEach(function (dot) {
        dot.classList.toggle('is-on', Number(dot.dataset.dot) <= n);
      });
    }

    function optionsHtml(list, odd) {
      return '<div class="otr-finder__options' + (odd ? ' is-odd' : '') + '">' + list.map(function (opt) {
        return '<button type="button" class="otr-finder__opt" data-value="' + opt[0] + '">' + opt[1] + '</button>';
      }).join('') + '</div>';
    }

    function paintQuestion(key, list, stepNum) {
      setDots(stepNum);
      var odd = list.length % 2 === 1;
      stage.innerHTML = '<h3 class="otr-finder__q">' + steps[key].q + '</h3>' + optionsHtml(list, odd) +
        (stepNum > 1 ? '<button type="button" class="otr-finder__back" data-back>Back</button>' : '');
      stage.dataset.step = key;
    }

    function paintPriority() {
      setDots(3);
      var list = priorityOptions();
      stage.innerHTML = '<h3 class="otr-finder__q">What is most important?</h3>' + optionsHtml(list, list.length % 2 === 1) +
        '<button type="button" class="otr-finder__back" data-back>Back</button>';
      stage.dataset.step = 'priority';
    }

    function paintResult() {
      var pick = recommend();
      var isTitan = pick === 'titan';
      var img = isTitan ? titanImg : travelImg;
      var alt = isTitan ? titanAlt : travelAlt;
      var name = isTitan ? 'Titan 5G Hotspot' : 'Travel Plan';
      var today = isTitan ? copy.titanToday : copy.travelToday;
      var month = isTitan ? copy.titanMonth : copy.travelMonth;
      var url = isTitan ? copy.titanUrl : copy.travelUrl;
      setDots(3);
      stage.innerHTML =
        '<div class="otr-finder__result">' +
          (img ? '<img class="otr-finder__photo" alt="' + alt.replace(/"/g, '') + '" src="' + img + '" width="160" height="160" loading="lazy" decoding="async">' : '') +
          '<div><span class="otr-finder__badge">OTR FLEX PAY</span>' +
          '<p class="otr-finder__kicker">' + copy.resultKicker + '</p>' +
          '<h3 class="otr-finder__name">' + name + '</h3>' +
          '<p class="otr-finder__why">' + why(pick) + '</p>' +
          '<p class="otr-finder__price">' + today + '</p>' +
          '<p class="otr-finder__after">' + month + '</p>' +
          '<a class="otr-finder__buy" href="' + url + '">' + copy.buy + '</a>' +
          '<button type="button" class="otr-finder__restart" data-restart>' + copy.again + '</button></div></div>';
      stage.dataset.step = 'result';
    }

    function go(step) {
      if (step === 'use') paintQuestion('use', steps.use.options, 1);
      else if (step === 'devices') paintQuestion('devices', steps.devices.options, 2);
      else if (step === 'priority') paintPriority();
      else paintResult();
    }

    stage.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-value]');
      var back = event.target.closest('[data-back]');
      var restart = event.target.closest('[data-restart]');
      if (restart) { answers = {}; go('use'); return; }
      if (back) {
        if (stage.dataset.step === 'priority') go('devices');
        else if (stage.dataset.step === 'devices') go('use');
        else if (stage.dataset.step === 'result') go('priority');
        return;
      }
      if (!opt) return;
      var value = opt.getAttribute('data-value');
      if (stage.dataset.step === 'use') { answers.use = value; go('devices'); }
      else if (stage.dataset.step === 'devices') {
        answers.devices = value;
        if (value === 'more') delete answers.priority;
        go('priority');
      } else if (stage.dataset.step === 'priority') {
        answers.priority = value;
        paintResult();
      }
    });

    go('use');
  }
function initializeFinders(scope) { scope.querySelectorAll("[data-otr-finder]").forEach(initializeFinder); }
initializeFinders(document);
document.addEventListener("shopify:section:load", function(event) { initializeFinders(event.target); });
})();
